var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarToggle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.78571 0C0.799494 0 0 0.799461 0 1.78571C0 2.7719 0.799494 3.57143 1.78571 3.57143H23.2143C24.2005 3.57143 25 2.7719 25 1.78571C25 0.799461 24.2005 0 23.2143 0H1.78571ZM1.78571 8.33333C0.799494 8.33333 0 9.1328 0 10.119C0 11.1052 0.799494 11.9048 1.78571 11.9048H23.2143C24.2005 11.9048 25 11.1052 25 10.119C25 9.1328 24.2005 8.33333 23.2143 8.33333H1.78571ZM1.78571 16.6667C0.799494 16.6667 0 17.4661 0 18.4524C0 19.4386 0.799494 20.2381 1.78571 20.2381H23.2143C24.2005 20.2381 25 19.4386 25 18.4524C25 17.4661 24.2005 16.6667 23.2143 16.6667H1.78571Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarToggle);
export default __webpack_public_path__ + "static/media/sidebar-toggle.a27f8320f2743262af43f6570b654f1f.svg";
export { ForwardRef as ReactComponent };